module.exports = __webpack_public_path__ + "img/2024-03-08a_1.27dd62c5.jpg";